import { OnInit, OnDestroy, Component, HostListener } from '@angular/core';
import { IContextService, DomainContext } from '@pershing/pershing-core';
import { Subscription } from 'rxjs';
import { NxiRestService } from '../../../services/NXI-Rest.service';
import { NxiWidgetParamsService } from '../../../services/NXI-WidgetParams.service';
import { NxiContextUtils } from '@pershing/nxi-common';

declare let dojoApp: any;

@Component({
    selector: 'dojo-IncomeCashPopup',
    templateUrl: './dojo-IncomeCashPopup.component.html'
})
export class DojoIncomeCashPopup implements OnInit, OnDestroy {
    inputValue: string = '';
    domain: string = '';
    subs: Subscription;
    acctRef: any;
    constructor(private contextService: IContextService,
                private nxiRestService: NxiRestService,
                private nxiWidgetParamsService: NxiWidgetParamsService) {
    }

    ngOnInit() {
        this.subs = this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
            let contextValue = NxiContextUtils.getContextFromDomainValue(domainContext);
            this.inputValue = contextValue.inputValue;
            this.acctRef = contextValue.hashValue;
            if (this.inputValue !== '' && this.acctRef !== 'undefined') {
                this.getDojoIncomeCashPopUp();
            }
        });
    }

    ngOnDestroy(): void {
        console.log('In DojoIncomeCashSummary destroy method');
        if (this.subs) {
            this.subs.unsubscribe();
        }
        if (dojoApp) {
            // pass necessary parameters to render dojo widgets
            dojoApp.destroyDojoIncomeCashPopup();
        }
    }
    openIncomeCashPopup() {
        if (dojoApp) {
            // pass necessary parameters to render dojo widgets
            dojoApp.renderDojoIncomeCashPopup(this.inputValue);
        }
    }
    getDojoIncomeCashPopUp() {
        this.nxiWidgetParamsService.getWidgetParams(this.acctRef, 'incomeCashFilter').subscribe(
            resp => {
                console.log('Retrived common REST IncomeCash Grid params : ', resp.response);
                if (resp.response) {
                    resp.response.storeUrl = this.nxiRestService.serviceUrl + resp.response.storeUrl;
                    resp.response.modAPIUrl = 'https://api-netxselect.wsodqa.com';
                    if (dojoApp) {
                        // pass necessary parameters to render dojo widgets
                        resp.response.nxiRestBaseUrl = this.nxiRestService.serviceUrl;
                        dojoApp.renderDojoIncomeCashPopup(resp.response);
                    }
                }
            }
        );
}
    // used to handle event in dojo widget as need
    @HostListener('click', ['$event'])
    onDojoWidgetEvent(evt): void {
        evt.preventDefault();
        console.log('evt in dojo widget - ', evt);

    }
}
